import React, {Component, Fragment} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import _ from "lodash";
import history from "../../../../libs/history";
import {
    fetchRoom,
    joinRoom,
    leaveRoom,
    lockRoom,
    readRoom,
    updateRoom
} from "../../../../creators/room";
import {getRoomEnhanced} from "../../../../selectors/room";
import {LoadingBar} from "../../../components/Loader";
import RoomHeader from "../components/RoomHeader";
import createLink from "../../../../libs/createLink";
import {fetchRoomMedias} from "../../../../creators/room.medias";
import DisplayImage from "../../../components/DisplayImage";
import Modal from "../../../components/Modal";
import RoomChat from "../components/RoomChat";

class Room extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleMediaViewer: false,
            openMediaIndex: 0
        }
        this._handleRoomMarkRead = _.debounce(this._handleRoomMarkRead, 100);
    }

    componentDidMount() {
        this._fetchRoom(this.props.match.params.room);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.match.params.room !== prevProps.match.params.room) {
            this._fetchRoom(this.props.match.params.room);
        }
    }

    _fetchRoom(roomId) {
        this.props.fetchRoom(roomId);
        this.props.fetchRoomMedias(roomId, {sort : "-createdAt"});
        this._handleRoomMarkRead(true);
    }

    _handleRoomMarkRead(isRead) {
        this.props.readRoom(this.props.match.params.room, {read: isRead});
    }

    _handleAddUser(userId) {
        this.props.joinRoom(this.props.match.params.room, {userId});
    }

    _handleChangeGroupTitle(groupName) {
        this.props.updateRoom(this.props.match.params.room, {groupName});
    }

    _handleRoomLock() {
        this.props.lockRoom(this.props.match.params.room, {locked: !this.props.room.isLocked});
    }

    _handleUserLeave(userId) {
        this.props.leaveRoom(this.props.match.params.room, {userId});
        if (this.props.room.owner._id === userId) history.push(createLink("messenger"));
    }

    _handleOpenMedia(mediaId) {
        //todo : bug possible : media ouvert à partir d'un message qui ne serait pas chargé dans les médias de la room
        this.setState({
            toggleMediaViewer: true,
            openMediaIndex: _.findIndex(this.props.medias, (o) => o._id === mediaId)
        });
    }

    _handleRemoveRoom(roomId){
        this.props.removeRoomByUser(roomId);
    }

    _closeOpenMedia() {
        this.setState({
            toggleMediaViewer: false,
            openMediaIndex: 0
        });
    }

    render() {
        return (!this.props.roomInitialized)
            ? <LoadingBar/>
            : <Fragment>
                <div className="layout-sidebar">
                    <div className="main-wrapper">
                        <RoomHeader
                            mobile
                            room={this.props.room}
                        />
                        <RoomChat
                            room={this.props.room}
                            handleOpenMedia={this._handleOpenMedia.bind(this)}
                            currentUser={this.props.currentUser}
                        />
                    </div>
                </div>
                <Modal toggle={this.state.toggleMediaViewer}
                       handleClose={() => this._closeOpenMedia()}>
                    <DisplayImage
                        handleClose={() => this._closeOpenMedia()}
                        mediaAttachementArray={this.props.medias}
                        currentIndex={this.state.openMediaIndex}
                    />
                </Modal>
            </Fragment>
    }
}

const mapStateToProps = (state, props) => {
    return {
        roomInitialized: state.room.initialized,
        roomLoading: state.room.loading,
        medias: state.roomMedias.data,
        mediasMore: state.roomMedias.more,
        room: getRoomEnhanced(state),
        currentUser: state.currentUser.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchRoomMedias,
    updateRoom,
    fetchRoom,
    readRoom,
    leaveRoom,
    joinRoom,
    lockRoom
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Room);